import { render } from "./ProjectSummaryDetails.vue?vue&type=template&id=de2a5680"
import script from "./ProjectSummaryDetails.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__